'use strict';

window.CFC = window.CFC || {};
window.CFC.NewsletterCta = (function($) {
  const DEBUG = false;
  const FORCE_HASH = 'show-newsletter-cta';
  let showPopup;
  let newsletterWasShownCookie = null;
  let newsletterPopup = null;
  
  function init() {
    showPopup = window.CFC_Vars.nlCtaEnabled || DEBUG;
    
    if (!showPopup) { return; }

    newsletterWasShownCookie = new Plaintext.FlagCookie("chicken-ca-newsletter-cta", { expiryDays: 30 });
    showPopup = (!newsletterWasShownCookie.isSet()) || (window.location.hash === `#${ FORCE_HASH }`);

    if (!showPopup) { return; }
    
    triggerCta();
  }
  
  function triggerCta() {
    const url = window.CFC_Vars.restUrl + 'cfc/v1/nl-cta/html';
    fetch(url)
    .then(r => r.json())
    .then(json => showCta(json.html))
    .catch(e => console.error(e));
  }
  
  function closePopup() {
    newsletterPopup.classList.remove('nl-cta__wrap--active');
    newsletterPopup.addEventListener('transitionend', () => newsletterPopup.remove());
  }
  
  function showCta(ctaHtml) {
    if (document.getElementById('nl-cta')) { return; }

    newsletterPopup = document.createElement('div');
    newsletterPopup.classList.add('nl-cta__wrap');
    newsletterPopup.id = 'nl-cta';
    newsletterPopup.setAttribute('aria-live', 'polite');

    if (DEBUG) {
      newsletterPopup.classList.add('nl-cta__wrap--debug');
    }
    
    newsletterPopup.innerHTML = ctaHtml;
    document.body.append(newsletterPopup);
    
    setTimeout(() => newsletterPopup.classList.add('nl-cta__wrap--active'), 0);
    
    newsletterPopup.querySelectorAll('[data-nl-cta-close]').forEach(closeBtn => closeBtn.addEventListener('click', closePopup));
    newsletterPopup.querySelector('form').addEventListener('submit', e => {
      window.CFC.Newsletter.submitNewsletterForm(e)
      .then(data => {
        const msgSelector = `.nl-cta__${ data.result }Msg`;
        newsletterPopup.querySelector(msgSelector).innerText = data.msg;
        
        newsletterPopup.classList.remove('nl-cta__wrap--error');
        newsletterPopup.classList.remove('nl-cta__wrap--success');
        newsletterPopup.classList.add('nl-cta__wrap--' + data.result);
      });
    });

    newsletterWasShownCookie.set();
  }
  
  $(init);
})(jQuery);